import { SOLANA_SCHEMA } from "@solana/web3.js";
export const PROGRAM_SCHEMA = SOLANA_SCHEMA;
//# sourceMappingURL=schema.js.map